export default __webpack_public_path__ + "static/brahms-h-moll-30d5dfcd0867c6bd54b01ac86c29df04.mp3";